export default function isToday (date) {
  return date.toDateString() === new Date(Date.now()).toDateString()
}
